var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPpticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4194 19.1723C12.4466 19.1737 12.4735 19.1761 12.5012 19.1761H18.7349C19.4641 19.1761 20.0572 18.5828 20.0572 17.8538V3.40313C20.0572 2.67419 19.4641 2.08083 18.7349 2.08083H12.5012C12.4738 2.08083 12.4466 2.08353 12.4194 2.0848V0.359985L0.252686 1.98373V19.2842L12.4194 20.95V19.1723ZM12.5012 2.83661H18.735C19.0475 2.83661 19.3016 3.0909 19.3016 3.4033V17.8542C19.3016 18.1665 19.0475 18.4209 18.735 18.4209H12.5012C12.4734 18.4209 12.4463 18.4164 12.4194 18.4124V11.5776C12.768 12.9037 13.9715 13.883 15.407 13.883C17.1153 13.883 18.4999 12.4984 18.4999 10.7903H15.407V7.69731C13.9714 7.69731 12.7678 8.67677 12.4194 10.003V2.84487C12.4463 2.84094 12.4732 2.83661 12.5012 2.83661ZM7.31169 10.8066C6.99928 11.1049 6.54061 11.2357 6.01152 11.2318C5.89492 11.2311 5.79006 11.2243 5.70927 11.2117V12.6573L4.843 12.6351V8.69037C5.11085 8.63618 5.48904 8.59064 6.02871 8.57633C6.58219 8.56196 6.98132 8.66074 7.25149 8.87416C7.51157 9.07706 7.68802 9.41825 7.68802 9.82371C7.68802 10.2294 7.55374 10.5742 7.31169 10.8066Z",
    fill: "#001B4A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.81622 9.32531C2.64972 9.32833 2.53755 9.34745 2.479 9.3659V10.5105C2.54799 10.5276 2.63349 10.5333 2.75156 10.5329C3.18865 10.5321 3.4611 10.2928 3.4611 9.89105C3.46114 9.52973 3.2272 9.31811 2.81622 9.32531Z",
    fill: "#001B4A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.07572 9.26803C5.89491 9.27109 5.77273 9.29129 5.70947 9.31037V10.504C5.78464 10.522 5.87741 10.5276 6.00564 10.5276C6.48167 10.5268 6.77819 10.2772 6.77819 9.8576C6.77819 9.48056 6.52289 9.26012 6.07572 9.26803Z",
    fill: "#001B4A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8269 10.3023V10.3032H18.92C18.92 9.43332 18.5591 8.6483 17.9808 8.08646L15.8269 10.3023Z",
    fill: "#001B4A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7942 9.75883L17.981 7.57194C17.3659 6.95654 16.5985 6.65661 15.792 6.6681L15.7935 9.75809L15.7942 9.75883Z",
    fill: "#001B4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpticon);
export default __webpack_public_path__ + "static/media/PPT ICON.2475443633ec0778ceffd9d4ed277675.svg";
export { ForwardRef as ReactComponent };